// A proxied site runs in a frame of the proxy's own page. An IntersectionObserver without a
// root measures against the top page's viewport, clipped by that frame, so its rootMargin
// cannot reach beyond what the frame shows: lazy loaders that start a little ahead of the
// visible part (DW's pictures) only loaded what was already on screen. In the site's top frame,
// the frame's own document is the root instead, which is what the implicit root is for a page
// that is not in a frame. Frames inside the site keep the implicit root, as they would have.

import { SCRAMJETCLIENT } from "@/symbols";
import { ScramjetClient } from "@client/index";

const OPTIONS = [
	"rootMargin",
	"scrollMargin",
	"threshold",
	"delay",
	"trackVisibility",
] as const;

export default function (client: ScramjetClient, self: any) {
	if (!self.IntersectionObserver) return;

	const siteTop = () => {
		try {
			return self.parent === self || !self.parent[SCRAMJETCLIENT];
		} catch {
			return true;
		}
	};
	const substituted = new WeakSet<object>();

	client.Proxy("IntersectionObserver", {
		construct(ctx) {
			const options = ctx.args[1] as IntersectionObserverInit | undefined;
			if ((options && options.root != null) || !siteTop()) return;
			const init: any = { root: self.document };
			if (options) {
				for (const key of OPTIONS) {
					const value = (options as any)[key];
					if (value !== undefined) init[key] = value;
				}
			}
			ctx.args[1] = init;
			const observer = ctx.call();
			substituted.add(observer);
			ctx.return(observer);
		},
	});

	client.Trap("IntersectionObserver.prototype.root", {
		get(ctx) {
			return substituted.has(ctx.this) ? null : ctx.get();
		},
	});
}
